var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('main',[_vm._m(0),_c('div',[_c('div',[_c('router-view')],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('noscript',[_c('iframe',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"src":"https://www.googletagmanager.com/ns.html?id=GTM-53CTZ4K","height":"0","width":"0"}})])
}]

export { render, staticRenderFns }